import { useModal } from "../../../utils/ModalContext";
import { FiX, FiChevronRight } from "react-icons/fi";
import SuccessModalStyleWrapper from "./SuccessModal.style";
import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import { useMoralis } from "react-moralis";
import successImg from "../../../assets/images/octopuses/happy1.png";
import {ImSpinner} from 'react-icons/im'
import { FaArrowUp } from "react-icons/fa";

const SuccessModal = () => {
  const { successModalHandle, hash } = useModal();

  return (
    <>
       <SuccessModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>Congratulations... 🎉🎊</h2>
              <button onClick={() => successModalHandle()}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="modal-message text-light">
                <h5>You Have succesfully minted ALPHA OCTOPUS</h5>
              </div>
              <div className="modal-img">
                <img src={successImg} alt="ALPHA OCTOPUS no wallet" style={{height:200}}/>
              </div>
              <p>
                See your transaction in <a href={`https://ropsten.etherscan.io/tx/${hash}`} target="_blank"> Etherscan <FaArrowUp /> </a>
              </p>
            </div>
            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </SuccessModalStyleWrapper>
    </>
  );
};

export default SuccessModal;
